var map = {
	"./baggage.svg": "7e53",
	"./ball.svg": "6cef",
	"./bonus.svg": "f577",
	"./business.svg": "8772",
	"./certificate.svg": "f3c3",
	"./clock.svg": "82ee",
	"./coins.svg": "6035",
	"./discount.svg": "47c6",
	"./dna.svg": "0c26",
	"./gallery.svg": "5920",
	"./gastro.svg": "4168",
	"./growth.svg": "ad3e",
	"./hands.svg": "138d",
	"./hat.svg": "3a1e",
	"./house.svg": "f04f",
	"./intro-bag.svg": "c827",
	"./intro-building.svg": "a37d",
	"./learning.svg": "7247",
	"./money.svg": "b6fc",
	"./network.svg": "f80b",
	"./people.svg": "e45c",
	"./phone.svg": "6de2",
	"./sale.svg": "a74a",
	"./windows.svg": "c243"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6bd5";